import { Button, ButtonProps } from 'components'
import { forwardRef } from 'react'
import { ScaleProps, useScale, useScaleProps } from '../../utils/scaleUtils'

export type Props = ScaleProps<Omit<ButtonProps, 'leftIcon' | 'rightIcon'>> & {
  LeftIcon?: any
  RightIcon?: any
}

const SButton = forwardRef<HTMLButtonElement, Props>(
  ({ borderRadius = 13, fontSize = 16, h = 40, px = 15, LeftIcon, RightIcon, ...props }, ref) => {
    const scale = useScale()
    const { styleProps, rest } = useScaleProps({ ...props, borderRadius, h, px, fontSize })

    const iconProps = { height: fontSize * scale, width: fontSize * scale }

    return (
      <Button
        leftIcon={LeftIcon && <LeftIcon {...iconProps} />}
        paddingInline={0}
        ref={ref}
        rightIcon={RightIcon && <RightIcon {...iconProps} />}
        {...styleProps}
        {...rest}
      />
    )
  }
)

export default SButton
